import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SpecialPriceState } from '@store/reducers';

export const selectSpecialPriceState = createFeatureSelector<SpecialPriceState>('specialPrice');

export const selectSpecialPriceLoading = createSelector(
  selectSpecialPriceState,
  (state: SpecialPriceState) => state.loading
);

export const selectSpecialPrice = createSelector(
  selectSpecialPriceState,
  (state: SpecialPriceState) => state.specialPrice
);

export const selectSpecialPriceList = createSelector(
  selectSpecialPriceState,
  (state: SpecialPriceState) => state.specialPriceList
);

export const selectSpecialPriceError = createSelector(
  selectSpecialPriceState,
  (state: SpecialPriceState) => state.error
);
